import styled from 'styled-components';

export const ContainerDays = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
`;
export const Days: any = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 30px;
  min-width: 30px;
  margin-left: 8px;
  border-radius: 40px;
  border: 2px solid ${(props: any) => props.color};
  text-align: center;
  font-size: 12px;
  color: ${(props: any) => props.color};
  font-family: 'Graphik-Regular';
`;
